import { render, staticRenderFns } from "./vaccinationDueList.vue?vue&type=template&id=100aabb0&scoped=true&"
import script from "./vaccinationDueList.vue?vue&type=script&lang=js&"
export * from "./vaccinationDueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100aabb0",
  null
  
)

export default component.exports